import { ReactElement } from 'react';

interface Props {
  className?: string;
}

export default function HorizontalRule({ className ='' }: Props ): ReactElement{
  return <div className={ `border-b border-initialFieldBorder -mx-8 md:-mx-12 mb-8 ${className}` }></div>;
}
